import AnalyticsTitle from "../AnalyticsTitle";
import { tt } from "../../../../utils/i18n/i18n";
import TSUtils from "../../../../utils/helpers/TSUtils";
import PieGraph from "../graphs/PieGraph";
import { buildNameForRepeatBusiness } from "../../helper/buildNameForRepeatBusiness";
import React, { useMemo, useState } from "react";
import AnalyticsData from "../../model/AnalyticsData";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import KC_Button from "../../../../designsystem/KC_Button/KC_Button";
import TitleAndTwoColumns from "../layout/TitleAndTwoColumns";
import AvgBasketModal from "../modals/AvgBasketModal";
import CurrencyProp from "../model/CurrencyProp";
import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";

interface Props {
  data: AnalyticsData | undefined;
  accountToDisplay: ManagedAccount;
  currency?: CurrencyProp;
}

export default function (props: Props) {
  const [showModal, setShowModal] = useState(false);

  const totalRepeatBiz = useMemo(() => {
    let res = 0;
    props.data?.distributionOfRepeatBusiness.forEach((d) => (res += d.count));
    return res;
  }, [props.data?.distributionOfRepeatBusiness]);

  const totalRepeatBizInCurrency = useMemo(() => {
    let res = 0;
    props.data?.distributionOfRepeatBusinessInCurrency.forEach(
      (d) => (res += d.count)
    );
    return res;
  }, [props.data?.distributionOfRepeatBusinessInCurrency]);

  if (!totalRepeatBizInCurrency) {
    return null;
  }

  return (
    <>
      <TitleAndTwoColumns
        title={
          <>
            <AnalyticsTitle
              title={tt("analytics_total_repeat_biz_title", {
                totalRepeatBiz,
                totalRepeatBizInCurrency: props.currency
                  ? TSUtils.formatAmountUsingIntl(
                      totalRepeatBizInCurrency,
                      props.currency.subUnits,
                      props.currency.trigram
                    )
                  : 0
              })}
            />
            <div className="d-flex flex-column flex-sm-row flex-grow-1 align-items-center justify-content-sm-between mt-2">
              <KC_UIText
                weight="reg"
                text={tt("modify_avg_basket_formula_text", {
                  avgBasket: props.currency
                    ? TSUtils.formatAmountUsingIntl(
                        props.accountToDisplay.avgBasket * props.currency.subUnits,
                        props.currency.subUnits,
                        props.currency.trigram
                      )
                    : 0
                })}
              />
              <KC_Button
                className="ml-2 ml-sm-auto mt-2 mt-sm-0"
                size="lg"
                extraStyle={{
                  width: "unset !important"
                }}
                text={tt("modify_avg_basket", {
                  avgBasket: props.currency
                    ? TSUtils.formatAmountUsingIntl(
                        props.accountToDisplay.avgBasket * props.currency.subUnits,
                        props.currency.subUnits,
                        props.currency.trigram
                      )
                    : 0
                })}
                isPrimary={true}
                onClick={() => setShowModal(true)}
              />
            </div>
          </>
        }
        left={
          !!props.data?.distributionOfRepeatBusiness?.length ? (
            <PieGraph
              title={tt("analytics_repeat_biz_breakdown_by_action")}
              distribution={props.data?.distributionOfRepeatBusiness}
              getDisplayNameForLabel={buildNameForRepeatBusiness}
              suffix={tt("analytics_clients_suffix")}
            />
          ) : (
            <></>
          )
        }
        right={
          !!props.data?.distributionOfRepeatBusinessInCurrency?.length ? (
            <PieGraph
              title={tt("analytics_distribution_in_euros_title", {
                currency: props.currency?.trigram
              })}
              distribution={props.data?.distributionOfRepeatBusinessInCurrency}
              getDisplayNameForLabel={buildNameForRepeatBusiness}
              isAmount={true}
              suffix={""}
              currency={props.currency}
            />
          ) : (
            <></>
          )
        }
      />
      <AvgBasketModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        currentAvgBasket={props.accountToDisplay.avgBasket}
        currency={props.currency}
      />
    </>
  );
}
